import React, { useMemo, useState } from 'react';
import { Button, Card, Col, Form, Image, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import logo from '../../images/logo-image.jpeg';
import { resetPassword } from '../../services/AuthService';

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const ResetPassword = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [email, setEmail] = useState(query.get('email') || '');
  const [token] = useState(query.get('token') || '');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!String(token || '').trim()) {
      await Swal.fire({
        icon: 'error',
        title: 'Reset link is invalid',
        text: 'Please open the reset link from your email again.',
        width: 420,
        confirmButtonColor: '#3a7afe',
      });
      return;
    }
    if (newPassword !== confirmPassword) {
      await Swal.fire({
        icon: 'error',
        title: 'Passwords do not match',
        width: 420,
        confirmButtonColor: '#3a7afe',
      });
      return;
    }
    setSubmitting(true);
    try {
      await resetPassword({ email, token, newPassword });
      await Swal.fire({
        icon: 'success',
        title: 'Password updated',
        text: 'You can now login with your new password.',
        width: 420,
        confirmButtonColor: '#3a7afe',
      });
      navigate('/external-login');
    } catch (error) {
      await Swal.fire({
        icon: 'error',
        title: 'Reset failed',
        text: error?.response?.data?.data || 'Invalid or expired token.',
        width: 420,
        confirmButtonColor: '#3a7afe',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="vh-100" style={{ backgroundColor: '#508bfc' }}>
      <Row className="d-flex justify-content-center align-items-center h-100">
        <Col md={4} lg={4} xl={4}>
          <Card className="shadow-2-strong" style={{ borderRadius: '1rem' }}>
            <Card.Body className="p-3">
              <div className="text-center">
                <Image src={logo} alt="Logo" className="mb-2" width={'40%'} />
                <h4 className="mb-3">Reset Password</h4>
              </div>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="form-outline mb-2">
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control-lg"
                    required
                    readOnly
                  />
                </Form.Group>
                <Form.Control type="hidden" value={token} readOnly />
                <Form.Group className="form-outline mb-2">
                  <Form.Control
                    type="password"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="form-control-lg"
                    required
                  />
                </Form.Group>
                <Form.Group className="form-outline mb-3">
                  <Form.Control
                    type="password"
                    placeholder="Confirm New Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="form-control-lg"
                    required
                  />
                </Form.Group>
                <div className="d-grid gap-2">
                  <Button type="submit" className="btn btn-primary btn-lg" disabled={submitting}>
                    Reset Password
                  </Button>
                </div>
                <div className="text-center mt-3">
                  <Link to="/external-login">Back to login</Link>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </section>
  );
};

export default ResetPassword;
